"use strict";

exports.__esModule = true;
exports.AVATAR_TEXT_TYPE = void 0;
const AVATAR_TEXT_TYPE = {
  initials: 'initials',
  plain: 'plain'
};
exports.AVATAR_TEXT_TYPE = AVATAR_TEXT_TYPE;
//# sourceMappingURL=constants.js.map